import gql from 'graphql-tag';

import { CardFragment,TeamFragment } from '../fragments';

export const UpdateTeamSubscription_Mutation = gql`
    mutation UpdateTeamSubscriptionMutation(
        $input: UpdateSubscriptionInput!
    ) {
        updateTeamSubscription(
            input: $input
        ) {
            invoiceStatus
            secret
            team {
                ...TeamFragment
            }
            card {
                ...CardFragment
            }
        }
    }
    ${TeamFragment}
    ${CardFragment}
`;
